export default __webpack_public_path__ + "static/media/vintage45g-2.9deedcf0.jpg";